import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/Layout';
import Login from './components/Login';
import Inicio from './components/Inicio';
import Horario from './components/Horario';
import Colillas from './components/Colillas';
import Notificaciones from './components/Notificaciones';
import Perfil from './components/Perfil';
import Agente from './components/Agente';
import PDV from './components/PDV';
import Inventario from './components/Inventario';
import Helados from './components/Helados';
import Caja from './components/Caja';
import Sobres from './components/Sobres';
import Produccion from './components/Produccion';
import Envios from './components/Envios';
import EnviosGeneral from './components/EnviosGeneral';
import InventarioProduccion from './components/InventarioProduccion';
import ProduccionHelados from './components/ProduccionHelados';

function RutaProtegida({ children }) {
  const { usuario, cargando } = useAuth();
  if (cargando) return <div style={{ display:'flex', alignItems:'center', justifyContent:'center', height:'100vh', color:'#9CA3AF' }}>Cargando...</div>;
  if (!usuario) return <Navigate to="/login" />;
  return <Layout>{children}</Layout>;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<RutaProtegida><Inicio /></RutaProtegida>} />
      <Route path="/horario" element={<RutaProtegida><Horario /></RutaProtegida>} />
      <Route path="/colillas" element={<RutaProtegida><Colillas /></RutaProtegida>} />
      <Route path="/notificaciones" element={<RutaProtegida><Notificaciones /></RutaProtegida>} />
      <Route path="/perfil" element={<RutaProtegida><Perfil /></RutaProtegida>} />
      <Route path="/agente" element={<RutaProtegida><Agente /></RutaProtegida>} />
      <Route path="/pdv" element={<RutaProtegida><PDV /></RutaProtegida>} />
      <Route path="/inventario" element={<RutaProtegida><Inventario /></RutaProtegida>} />
      <Route path="/helados" element={<RutaProtegida><Helados /></RutaProtegida>} />
      <Route path="/caja" element={<RutaProtegida><Caja /></RutaProtegida>} />
      <Route path="/sobres" element={<RutaProtegida><Sobres /></RutaProtegida>} />
      <Route path="/produccion" element={<RutaProtegida><Produccion /></RutaProtegida>} />
      <Route path="/envios" element={<RutaProtegida><Envios /></RutaProtegida>} />
      <Route path="/envios-general" element={<RutaProtegida><EnviosGeneral /></RutaProtegida>} />
      <Route path="/inventario-produccion" element={<RutaProtegida><InventarioProduccion /></RutaProtegida>} />
      <Route path="/produccion-helados" element={<RutaProtegida><ProduccionHelados /></RutaProtegida>} />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}

export default function App() {
  useEffect(() => {
    // Registrar Service Worker
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('/sw.js')
        .then(reg => console.log('SW registrado:', reg.scope))
        .catch(err => console.log('SW error:', err));
    }
  }, []);

  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster position="top-center" toastOptions={{ duration: 3000, style: { borderRadius: '12px', fontSize: '14px' } }} />
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}
